module.exports = __webpack_public_path__ + "img/cross-red.d16d7ef1.png";